import { makeStyles } from '@material-ui/core/styles';
import { Theme } from 'enum';

export const useStyle = makeStyles((theme) => {
    const isDarkMode = theme.palette.type === Theme.Dark;
    return {
        container: {
            width: '100%',
            overflow: 'hidden',
            backgroundColor: isDarkMode ? 'rgb(42,42,42)' : 'rgb(255,255,255)',
        },
        headline: {
            padding: theme.spacing(2, 2.5),
            backgroundColor: isDarkMode ? 'rgb(38,38,38)' : 'rgb(250,250,250)',
        },
        content: {
            padding: theme.spacing(1, 0),
            '& ul': {
                padding: 0,
                margin: 0,
                listStyle: 'none',
            },
        },
    };
});
